export enum MfaDataStatus {
  Valid = "valid",
  Invalid = "invalid",
  Empty = "empty",
}
